"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pikachuData_1 = require("./assets/pikachuData");
var pikachuEgg = {
    name: "pikachu",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["p", "i", "k", "a", "c", "h", "u"],
        captureOnInputs: false,
    },
    onStart: function () {
        var data = "https://i.imgur.com/hALdLiE.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "250px";
        img.style.height = "149px";
        img.style.transition = "1s all";
        img.style.position = "fixed";
        img.style.left = "calc(50% - 125px)";
        img.style.bottom = "-149px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.bottom = "0px";
        }, 50);
        window.setTimeout(function () {
            shock.style.width = "100%";
            shock.style.height = "100%";
            shock.style.left = "0";
            shock.style.top = "0";
            shock.style.position = "fixed";
            shock.style.zIndex = "9999999";
            shock.style.background = "#fffb95";
            shock.style.opacity = "0";
            document.body.appendChild(shock);
            for (var x = 0; x < 81; x++) {
                (function (x) {
                    window.setTimeout(function () {
                        if (x % 2 === 0) {
                            shock.style.opacity = "0";
                        }
                        else {
                            shock.style.opacity = "0.3";
                        }
                    }, x * 25);
                })(x);
            }
        }, 2500);
        window.setTimeout(function () {
            img.style.bottom = "-149px";
        }, 4300);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
            shock.parentNode.removeChild(shock);
        }, 5400);
        // Play sound;
        var sound = new Audio("data:audio/mp3;base64," + pikachuData_1.audioInit);
        sound.play();
    },
};
exports.default = pikachuEgg;
